(function () {
  document.addEventListener("DOMContentLoaded", function () {
    var backdrop = document.getElementById("rules-popup-backdrop");
    if (!backdrop) return;

    var closeBtn = backdrop.querySelector(".rules-popup-close");

    function openPopup() {
      backdrop.classList.add("is-visible");
      backdrop.setAttribute("aria-hidden", "false");
      document.body.style.overflow = "hidden";
    }

    function closePopup() {
      backdrop.classList.remove("is-visible");
      backdrop.setAttribute("aria-hidden", "true");
      document.body.style.overflow = "";
    }

    // ⏱ 7-second delay before showing
    setTimeout(openPopup, 10000);

    // Close button
    if (closeBtn) {
      closeBtn.addEventListener("click", closePopup);
    }

    // Click outside card closes popup
    backdrop.addEventListener("click", function (e) {
      if (e.target === backdrop) {
        closePopup();
      }
    });

    // ESC key closes popup
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && backdrop.classList.contains("is-visible")) {
        closePopup();
      }
    });
  });
})();
